import DefaultLayout from "../../../layouts/Default"
import RadioList from "../components/RadioList"
import InfoContainer from "../components/InfoContainer"
import { diSanaShippingPs } from "@/app/utils/constants"

const ShippingP = () => {
  return (
    <DefaultLayout>
      <InfoContainer title="Shipping Policy">
        {diSanaShippingPs.map((s, i) => (
          <div key={i}>
            <RadioList detail={s} />
          </div>
        ))}
      </InfoContainer>

    </DefaultLayout>
  )
}

export default ShippingP